import { User } from './../index';

export class CompanyUsers {
    public CompanyId: number;
    public Users: User[] = [];
}
